class CartDrawerReviews extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Ensure the element has the Flickity class and images to display
    if (this.classList.contains("flickity") && this.children.length) {
      this.initializeCarousel();
    } else {
      console.error(
        "CartDrawerReviews: No valid content or Flickity class missing."
      );
    }
  }

  disconnectedCallback() {
    if (this.carousel) {
      this.carousel.unload(); // Unload Flickity when element is removed
    }
  }

  initializeCarousel() {
    // Wait for images to load before initializing Flickity
    this.waitForImagesToLoad(() => {
      const prevButton = this.querySelector("[data-prev-button]") || null;
      const nextButton = this.querySelector("[data-next-button]") || null;

      this.carousel = new theme.Carousel(
        this,
        {
          prevNextButtons: false,
          adaptiveHeight: true,
          pageDots: true,
          contain: true,
          cellAlign: "center",
          groupCells: false, // Show one slide at a time
          rightToLeft: theme.config.rtl,
        },
        { previous: prevButton, next: nextButton }
      );

      this.carousel.load(); // Initialize Flickity carousel

      // Force Flickity to update its dimensions
      this.carousel.slider.reloadCells();
      this.carousel.slider.resize();
      window.dispatchEvent(new Event("resize")); // Trigger global resize
    });
  }

  waitForImagesToLoad(callback) {
    const images = this.querySelectorAll("img");
    const totalImages = images.length;
    let loadedCount = 0;

    if (!totalImages) {
      callback(); // No images to load
      return;
    }

    images.forEach((img) => {
      if (img.complete) {
        loadedCount++;
        if (loadedCount === totalImages) callback();
      } else {
        img.addEventListener("load", () => {
          loadedCount++;
          if (loadedCount === totalImages) callback();
        });
        img.addEventListener("error", () => {
          loadedCount++;
          if (loadedCount === totalImages) callback();
        });
      }
    });
  }
}

customElements.define("cart-drawer-reviews", CartDrawerReviews);
document.addEventListener("page:loaded", function () {
  window.dispatchEvent(new Event("resize")); // Trigger global resize
});


/*
 * Bundle Removed — Cart Cleanup Handler
 *
 * Triggered when the Checkout UI Extension detects a bundle in cart that is
 * missing the required `_ref` line item property (meaning the customer bypassed
 * the bundle PDP and never configured the bundle). The extension redirects the
 * customer back to the product page with:
 *
 *   ?bundle_removed=true&line_key=VARIANT_ID1,VARIANT_ID2
 *
 * This script runs on every page load but exits immediately if the parameter
 * is not present. When detected it:
 *   1. Cleans the URL parameters via history.replaceState (no page reload)
 *   2. Fetches /cart.js to find the real storefront line keys by matching variant IDs
 *   3. Calls /cart/change.js to remove each matched line item (quantity: 0)
 *   4. Updates the cart count and re-renders the cart drawer with fresh section HTML
 *
 * The removal is done theme-side (not in the extension) to avoid cross-origin
 * issues and Safari cancelling in-flight fetch requests on navigation.
 */

(function () {
  var url = new URL(window.location.href);
  if (url.searchParams.get('bundle_removed') !== 'true') return;

  var lineKey = url.searchParams.get('line_key');

  url.searchParams.delete('bundle_removed');
  url.searchParams.delete('line_key');
  history.replaceState(null, '', url.toString());

  function updateCartUI(cart) {
    document.querySelectorAll('cart-count').forEach(function (el) {
      el.innerText = cart.item_count;
      el.hidden = cart.item_count === 0;
    });

    var cartDrawer = document.querySelector('cart-drawer');
    var sectionId = cartDrawer && cartDrawer.getAttribute('data-section-id');
    if (!sectionId) return;

    fetch('/?section_id=' + sectionId)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var miniCartId = 'MiniCart-' + sectionId;
        var existing = document.getElementById(miniCartId);
        var updated = parsed.getElementById(miniCartId);
        if (existing && updated) {
          existing.innerHTML = updated.innerHTML;
        }
      });
  }

  if (lineKey) {
    var variantIds = lineKey.split(',').filter(Boolean);

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var matchedKeys = cart.items
          .filter(function (item) {
            return variantIds.indexOf(String(item.variant_id)) !== -1;
          })
          .map(function (item) { return item.key; });

        if (!matchedKeys.length) {
          updateCartUI(cart);
          return;
        }

        var removals = matchedKeys.map(function (key) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 })
          }).then(function (r) { return r.json(); });
        });

        Promise.all(removals).then(function (results) {
          var last = results.filter(Boolean).pop();
          if (last) updateCartUI(last);
        });
      });
  } else {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartUI(cart); });
  }
})();